<template>
  <div class="col-lg-4 space-media-card" v-on:click="onClick" v-bind:class="{ mediaSelected: selected}">
    <div v-on:click="onClick" v-bind:style="'background-image: url(' + src + ')'" class="media-square" ></div>
    <button @click="onDelete" type="button" class="btn btn-danger w-100">Delete</button>
  </div>
</template>

<script>
  export default {
    props: {
      selected: {
        type: Boolean,
        default: false,
      },
      media: {
        type: Object,
        default: function () {
          return {
            id: "",
            title: "",
            filename: "",
          };
        },
      },
    },
    computed: {
      src() {
        return (
          process.env.VUE_APP_API_URL +
          "/media/thumbnails/300/" +
          this.media.id +
          ".png"
        );
      },
    },
    methods: {
      onClick() {
        this.$emit("selected", this.media.id);
      },
      onDelete() {
        this.$emit("delete", this.media.id);
      },
    },
  };
</script>

<style scoped>
  .mediaLibraryCard {
    border-style: solid;
    border-width: 1px;
  }

  .mediaSelected {
    border-width: 3px;
    border-color: green;
  }
</style>